import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AppInitStatus extends BaseComponent {
	
	constructor() {
		super();
		
		var appInitGrid = this;
		setTimeout(function(){
			appInitGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var appInitGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},	
				{
					tag: 'dl-action-button',						
					theme: 'secondary',
					itemid: 'run',
					disabled: true,
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_SYSTEM:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:play', ' Run')
					],
					listeners: {
						click: function() {
							actionRun(grid.selectedItems[0]);
						}
					}
				},	
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'processKey',
					header: 'Process Key',					
					width: '9em'
				},
				{						
					path: 'message',
					header: 'Message',						
					'flex-grow': '1'						
				},
				{						
					path: 'appliedStatus',
					header: 'Applied Status',
					'text-align': 'center',
					width: '5em'
				},
				{						
					path: 'updateDts',
					header: 'Update Dts',					
					width: '5em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}				
				},
				{						
					path: 'fullClassName',
					header: 'Full Class Name',					
					width: '12em'
				},
				{						
					path: 'appliedVersion',
					header: 'Applied Version',
					'text-align': 'center',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'run').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'run').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = false;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		appInitGrid.append(flexLayout);
		
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			Service.getApplicationService().getAppInitStatuses().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = data;				
			});
			
		};
		actionRefresh();
		
		var actionRun = function(record) {			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Run',
				message: 'Are you sure you want to run: ' + record.processKey + '? <br><br>Note: This will run in the background.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Starting Run...');
							Service.getApplicationService().runInitStatus(record.processKey).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Started: ' + record.processKey, {									
									theme: 'success'
								});
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});	
			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete: ' + record.processKey + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Init Status...');
							Service.getApplicationService().deleteInitStatus(record.processKey).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed: ' + record.processKey, {									
									theme: 'success'
								});
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};	
	}
	
};
customElements.define('dl-app-init-status', AppInitStatus);

